import ElIcon from './src/icon.vue';

/* istanbul ignore next */
ElIcon.install = function(Vue) {
  Vue.component(ElIcon.name, ElIcon);
};

export default ElIcon;



// WEBPACK FOOTER //
// ./src/components/element/packages/icon/index.js